<div class="mfa-root" (mousemove)="onMouseMove($event)">

  <div #canvasWrapper class="canvas-wrap"></div>
  <div class="vignette"></div>

  <header class="mfa-header">
    <div class="brand-mark">
      <div class="brand-icon">N</div>
      <span class="brand-label">NGX FINANCIAL</span>
    </div>
    <div class="header-right">
      <button class="theme-btn" (click)="themeService.toggleTheme()" type="button">
        <span class="theme-icon">{{ (themeService.theme$ | async) === 'dark' ? '☾' : '☀' }}</span>
        <span>{{ (themeService.theme$ | async) === 'dark' ? 'DARK' : 'LIGHT' }}</span>
      </button>
    </div>
  </header>

  <main class="mfa-main">
    <div class="float-wrap">
      <div class="mfa-card" #cardEl>

        <div class="card-eyebrow">VERIFICAÇÃO DE SEGURANÇA</div>

        <!-- TOTP -->
        <ng-container *ngIf="!showRecovery">
          <h1 class="card-title">Autenticação em<br>dois fatores</h1>
          <p class="card-sub">Digite o código de 6 dígitos do seu aplicativo autenticador.</p>

          <form (ngSubmit)="onSubmit()" class="mfa-form">
            <div class="otp-row">
              <input *ngFor="let i of [0,1,2,3,4,5]"
                     #otpInput
                     type="text"
                     inputmode="numeric"
                     maxlength="1"
                     class="otp-box"
                     [class.filled]="digits[i]"
                     autocomplete="one-time-code"
                     (focus)="onFocus($event, i)"
                     (input)="onDigit($event, i)"
                     (keydown)="onKey($event, i)"
                     (paste)="onPaste($event)" />
            </div>

            <button type="submit" class="submit-btn" [disabled]="digits.join('').length < 6 || loading">
              <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
              <span *ngIf="!loading">Verificar código</span>
            </button>
          </form>
        </ng-container>

        <!-- Recovery -->
        <ng-container *ngIf="showRecovery">
          <h1 class="card-title">Código de<br>recuperação</h1>
          <p class="card-sub">Use um dos códigos de recuperação gerados ao ativar o MFA.</p>

          <form [formGroup]="recoveryForm" (ngSubmit)="onRecovery()" class="mfa-form">
            <div class="field-group">
              <label class="field-label">CÓDIGO DE RECUPERAÇÃO</label>
              <input type="text" formControlName="code" placeholder="xxxx-xxxx-xxxx"
                     class="field-input" autocomplete="off" autofocus>
            </div>

            <button type="submit" class="submit-btn" [disabled]="recoveryForm.invalid || loading">
              <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
              <span *ngIf="!loading">Recuperar acesso</span>
            </button>
          </form>
        </ng-container>

        <div class="card-footer">
          <button class="link-btn" type="button" (click)="toggleRecovery()">
            {{ showRecovery ? 'Usar código do autenticador' : 'Usar código de recuperação' }}
          </button>
          <span class="separator">·</span>
          <a routerLink="/login" class="link-btn">Voltar ao login</a>
        </div>

      </div>
    </div>
  </main>

  <div class="mfa-hint">AUTENTICAÇÃO MULTIFATOR ATIVA</div>
  <div class="flash-overlay" #flashEl></div>

</div>
